import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class TourService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  getEntireTourCalendar(all: boolean) {
    if (all){
      return this.http.get("/api/tour/all").map(res => res.json()); 
    }
    else {
      return this.http.get("/api/tour").map(res => res.json());
    }
  }

  create(tour: any) {
    return this.authHttp.post("/api/tour", tour).map(res => res.json())
  }

  delete(id: number) {
    // console.log("Delete Tour: " + id)
    return this.authHttp.delete("/api/tour/" + id).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/tour.service.ts